import React from 'react'
import { QuestionIcon } from 'components/icons'
import { TooltipWrap, DefaultTooltip } from './styles'

export interface TooltipProps {
  text: string
  children?: React.ReactNode
}

const Tooltip: React.FC<TooltipProps> = ({ text }) => (
  <TooltipWrap>
    <QuestionIcon />
    <DefaultTooltip>{text}</DefaultTooltip>
  </TooltipWrap>
)

export default Tooltip

export { Tooltip }
